module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showKlickpagesHeader) ? _c('klickpages-header', {
    attrs: {
      "klickartURL": _vm.klickartURL,
      "jwtSecret": _vm.jwtSecret,
      "hotmartURL": _vm.hotmartURL
    }
  }) : _vm._e(), _vm._v(" "), _c('error-page', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    attrs: {
      "error": _vm.error
    }
  }), _vm._v(" "), _c('router-view', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.error),
      expression: "!error"
    }]
  }), _vm._v(" "), _c('klickpages-support-chat', {
    attrs: {
      "klickartURL": _vm.klickartURL
    }
  })], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-05d12b0f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 749
 ** module chunks = 1
 **/